import i18n from 'src/i18n.js';

export const localData = () => ({
    searchAddButton: [
        { title: i18n.t('reportUsage.addItems.title') },
        { title: i18n.t('reportUsage.searchItems.title') },
        { title: i18n.t('reportUsage.searchItems.ScanItems') },
        { title: i18n.t('scheduleSurgery.quickOrder.bulkAddText') },
    ],
});
